export const APP_MANAGED_ROUTES = {
  LANDING_PAGE: '/',
  HOME: '/home',
  // Mobile home deeplink (Plan Switcher submit + single-plan gate auto-select); web
  // serves Home at HOME, so this path redirects there. See GEIS-492.
  MEMBER_HOME: '/member/home',
  SIGN_IN: '/sign-in',
  SIGN_OUT: '/sign-out',
  // Support-agent entry. Auth0 lands the agent here after the support SAML
  // login, and this route starts the app's own login on that connection.
  START_LOGIN: '/start-login',
  PERSONAL_INFO: '/settings/personal-info',
  COMMUNICATION_PREFERENCES: '/settings/communication-preferences',
  SWITCH_ACCOUNTS: '/switch-accounts',
  NOTIFICATIONS: '/settings/notifications',
  SUPPORT: '/support',
  PREMIUM_PAYMENTS: '/premium-payments',
  FAQ: '/faq',
  // Reached from the Home "Health alerts" card. Flat, like the routes above:
  // the CTA is content-managed and one Contentful value serves web, iOS and
  // Android, so all three register this same path.
  HEALTH_ALERTS: '/health-alerts',
  // Pharmacy benefits static page, entered from the Benefits landing and Get
  // Care tiles. Flat and content-managed like HEALTH_ALERTS above.
  //
  // The tiles MUST deeplink to this plain path, not to
  // `/masonry/2.0/pharmacy$root?namespace=default`. `/masonry/2.0/…` is the
  // native (iOS/Android) URL form; web's SDK counterpart is
  // `/generic-masonry-page/2.0/:version/:id`, and this app registers neither.
  // Masonry's deeplink handler passes any `/`-prefixed url to the router
  // verbatim, so the native form falls through to the `/*` catch-all and
  // renders PageNotFound — silently, since the handler still reports success.
  PHARMACY: '/pharmacy',
  // Perks & Discounts static page, entered from the "View perks & discounts"
  // CTA on the Benefits landing page (services#45949). Flat and
  // content-managed, exactly like PHARMACY above — and subject to the same
  // `/masonry/2.0/…` caveat documented there.
  //
  // The spec asserts this contract at
  // nodes/geisinger/benefits/landingPage/mainContent/tabs/active/
  // perksAndDiscountsActiveGridLayout.yaml: "`/perks` is a client-registered
  // internal route … must match the clients' route tables character for
  // character." Until this entry existed it did not, and the CTA rendered
  // PageNotFound.
  PERKS: '/perks',
  // Wellness & Rewards benefits page. Kebab-case of the tree's own
  // `wellnessRewards` id, following HEALTH_ALERTS (`homePage$healthAlertsDetail`
  // → `/health-alerts`) and PHARMACY rather than PERKS — PERKS is `/perks` only
  // because services#45949 had already shipped a CTA emitting that literal, and
  // a client route has to match an existing CTA character for character.
  //
  // Nothing emits this path yet: no CTA anywhere in the spec tree targets
  // `wellnessRewards$root` (the Benefits landing "Healthy rewards" card is
  // informational and carries no destination). So this is the first spelling of
  // the path, and iOS and Android must register the same one.
  WELLNESS_REWARDS: '/wellness-rewards',
  // Full "Suggested for you" list (GEIS-2499). The Journey landing carousel's
  // View all emits this literal (services
  // nodes/geisinger/journey/landing/shared/suggestedViewAll.pkl `webUrl`), so
  // the two must match character for character. Web-only: the native stack
  // links to `/masonry/2.0/journey$suggested$root` instead.
  SUGGESTED_ACTIVITIES: '/suggested-activities',
};
